export default __webpack_public_path__ + "static/media/g-xxl-4.2e950dd0.png";